/* global Intl -- eslint's browser globals omit it; format.js does the same */
import { buildCountryData, defaultCountries, parseCountry } from "react-international-phone";

// The phone input's country list comes with English names. Intl knows every
// region's name in every language, so the list is renamed rather than
// translated by hand.
const cache = new Map();

export function localizedCountries(language) {
	if (cache.has(language)) return cache.get(language);

	const names = new Intl.DisplayNames([language === "en" ? "en" : "bs"], { type: "region" });
	const collator = new Intl.Collator(language === "en" ? "en" : "bs");

	const countries = defaultCountries
		.map((country) => {
			const parsed = parseCountry(country);
			return buildCountryData({ ...parsed, name: names.of(parsed.iso2.toUpperCase()) ?? parsed.name });
		})
		.sort((a, b) => collator.compare(parseCountry(a).name, parseCountry(b).name));

	cache.set(language, countries);
	return countries;
}
